import * as React from "react";
const TebLogo = (props) => (
  <svg
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="202 327 190 190"
    style={{
      enableBackground: "new 0 0 595.3 841.9",
    }}
    xmlSpace="preserve"
    {...props}
  >
    <style type="text/css">
      {
        "\n\t.st0{fill:none;stroke:#FFFFFF;stroke-width:0.216;stroke-miterlimit:2.6131;}\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#00A76D;}\n\t.st2{fill-rule:evenodd;clip-rule:evenodd;}\n\t.st3{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\n"
      }
    </style>
    <g>
      <polygon
        className="st0"
        points="202.1,327 392.1,327 392.1,517 202.1,517 202.1,327  "
      />
      <polygon
        className="st1"
        points="207.1,380.5 290,380.5 290,463.5 207.1,463.5 207.1,380.5  "
      />
      <path
        className="st2"
        d="M359.3,409.5c0.2,2.7,0.4,9.5,0.4,11.9c0,2.3,0,9.9-0.4,13.2l0,0.3h13.9c6.8,0,14-1.8,14-7 c0-3.3-2.7-5.7-7.9-7c3.8-0.8,6.3-3.1,6.3-5.7c0-4.2-5.7-5.8-11-5.9c0,0-15.3,0-15.3,0L359.3,409.5L359.3,409.5z M370,412.1 c5.8,0,7.9,1,7.9,3.8c0,0.7-0.3,1.4-0.8,1.9c-1.1,1.1-3.3,1.7-6.1,1.6H371l-1.6,3.6h1.6c3.2-0.1,6,0.8,7.4,2.3c0.7,0.7,1,1.5,1,2.3 c0,2.8-2.9,4.3-8.6,4.3c-1,0-2.5,0-3.5-0.1c-0.2-3.8-0.2-8.8-0.2-10.4c0-1.8,0.1-5.8,0.2-9.2C368,412.1,369.1,412.1,370,412.1 L370,412.1z"
      />
      <path
        className="st2"
        d="M356.5,434.8v-3.7c-5.6,0.3-11.2,0.3-16.8,0.4c-0.1-2.6-0.2-5.8-0.2-8.1l11,0.2v-3.9l-11,0.2 c0-2,0.1-4.9,0.2-7.3c1.6,0,2.4-0.1,3.6-0.1c4.1,0,8.3-0.1,12.4,0.3v-3.7h-16.9v0h-7l0,0.3c0.2,2.7,0.4,9.5,0.4,11.9 c0,2.3,0,9.9-0.4,13.2l0,0.3H356.5L356.5,434.8z"
      />
      <path
        className="st2"
        d="M318.9,434.8l0-0.3c-0.4-3.3-0.4-10.9-0.4-13.2c0-1.8,0.1-5.8,0.2-9c4.5,0.1,5.7,0.1,9.7,0.5v-3.7h-27.1v3.7 c3.9-0.4,5.2-0.4,9.7-0.5c0.1,3.1,0.2,7.2,0.2,9c0,2.3,0,9.9-0.4,13.2l0,0.3H318.9L318.9,434.8z"
      />
      <path
        className="st3"
        d="M271.8,402.3c-5.1,3-6.7,3.2-12.3,6.6c3.2-3.5,4.3-5,6.4-7.9c-5.1,0.3-12.6,0.9-17.9,2.1 c4.6-2.5,13.8-5.2,18.7-5.9c-1.1-1.6-10.2-6.5-12.5-7.4c7.2,0.6,16,3.2,20.3,5.9c1.7-0.5,3.4-0.6,6.5-0.8c-0.8,1.4-0.8,2.2-3.9,4.2 c0.8,2.3-1.2,14.8-2.8,18.1C274.2,411.8,273.7,405.2,271.8,402.3L271.8,402.3z"
      />
      <path
        className="st3"
        d="M234.3,447.2c-3-1.1-5.1-2.4-7.4-4.5c0.7-1.9,1.5-3.4,2.8-5.3c-2.4,0.3-4.1,0.6-6.2,1 c-1.7-2.9-2.4-5.8-3.3-9.7c-0.5,4.2-0.6,7.1,0,10.5c-1.9,0.5-3.2,1-4.8,1.7c2.2,1.3,3.9,2.4,6.4,3.5c1.3,2.8,2.7,4.7,4.8,6.9 c-0.5-1.8-0.6-3.3-0.5-5.2C228.9,446.7,231.2,447.1,234.3,447.2L234.3,447.2z"
      />
      <path
        className="st3"
        d="M242,405.6L242,405.6c-0.9,1.2-2,3.4-2.3,4.4c7.6,1,13.7,4.9,13.7,4.9h0c-6.7-1.2-10.1-1-12.6-0.8 c-2.5,0.2-3,0.5-3,0.5c-1.8,3.9-2.9,10.6-2.9,10.6c-1.2-2.9-3-8.7-3-8.7c-3.3,1.8-11,9-11,9h0c4.2-8.5,8.5-12.3,8.5-12.3h0 c-1.5-1.5-5.3-2.2-8.2-2.3c1.5-0.6,5.2-1.3,8.1-1.4c2.9-0.1,4.6,0.1,4.6,0.1h0C236.7,407.5,240.6,405.8,242,405.6L242,405.6z"
      />
      <path
        className="st3"
        d="M250,441.9c-1.3,1.8-2.5,3.2-4,4.9c-2.6,0.7-4.6,1-7.1,1c1.5,0.8,3,1.3,4.6,1.6c-1.6,1.4-2.9,2.5-4.5,3.5 c2.6-0.6,6-1.7,8.5-3.2c1.3,0,2.6,0,3.5-0.2c-0.2-0.8-0.4-1.4-0.6-2.4c2.4-1.9,4.1-3.5,6.1-5.5c-2.1,1.5-3.9,2.6-6.4,3.7 C250.1,444.1,250.1,443.2,250,441.9L250,441.9z"
      />
    </g>
  </svg>
);
export default TebLogo;
